export default __webpack_public_path__ + "static/media/gallery_4_1280.726360de.webp";